import React from 'react';

export default function EmbededTweetBox({ html }) {
  return <div dangerouslySetInnerHTML={{ __html: html }}></div>
}